import React from 'react';
import './index.less';


const PageScholar = props => {
    const { anchor, current, BubbleMachine } = props;
    const graphVW = anchor.isMobile ? 1.52 : 0.9635;

    return (
        <div className='pageScholar'>
            <div className="contents">
                <div className="scholar_left">
                    <div className='scholar_left_img scholar_left_img1'>
                        <img src="/assets/scholar_img.png" style={{ width: `${anchor.scale * 900}px`, minWidth: 300 }} />
                        {
                            current == 1 && <BubbleMachine anchor={anchor} vw={graphVW} bgColor="#699af2" />
                        }
                    </div>
                </div>
                <div className="scholar_right">
                    <div className='scholar_right_img scholar_right_img1'>
                        <div style={{ marginBottom: `${anchor.isMobile ? 14 : 20}px` }}>
                            <img src='/assets/author.png' style={{ width: `${anchor.scale * 92}px`, minWidth: 50 }} />
                        </div>
                        <div>
                            <img src='/assets/scholar_text.png' style={{ width: `${anchor.scale * 348}px`, minWidth: 150 }} />
                        </div>
                    </div>
                    {
                        !!anchor.isMobile
                        &&
                        <img
                            src='/assets/top_text_6.png'
                            className='top_text_6'
                            style={{ width: `${anchor.scale * 26}px`, minWidth: 16 }}
                        />
                    }
                </div>

            </div>
        </div>
    )
}

export default PageScholar;